import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "api/apiClient.ts";

// Define User Type
interface User {
  _id: string;
  name: string;
  email: string;
  role: string;
  phone: string;
  state: string;
}
// Fetch users function
const fetchUsers = async (): Promise<User[]> => {
  const { data } = await apiClient.get("/users");

  if (data.status !== "success" || !Array.isArray(data.data)) {
    throw new Error("Invalid response format");
  }
  return data.data;
};

// Hook to get users
export const useUsers = () => {
  return useQuery({
    queryKey: ["users"],
    queryFn: fetchUsers,
  });
};

// Hook to update user
export const useUpdateUser = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, state, role }: { id: string; state: string; role: string }) => {
      const response = await apiClient.patch(`/users/update/${id}`, { state, role });
      return response.data; // Ensure we return the updated user
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["users"] });
    },
  });
};
